/** @jsx jsx */
// @ts-check
import { jsx } from 'theme-ui';
import sizes from './sizes';

/**
 * A download icon.
 * @param {object} props
 * @param {string} [props.className]
 * @param {string} [props.size] The icon size.
 */
export default function PreviewIcon({ className, size = 'xsmall' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      // @ts-ignore
      sx={{
        width: sizes[size],
        height: sizes[size],
        verticalAlign: 'middle',
      }}
      className={className}
      viewBox="0 0 17 15"
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M8.5 3c5.168 0 7.326 3.988 7.415 4.157a.736.736 0 010 .686C15.826 8.013 13.668 12 8.5 12S1.174 8.012 1.085 7.843a.736.736 0 010-.686C1.175 6.987 3.332 3 8.5 3zm0 2.362A2.14 2.14 0 006.363 7.5 2.14 2.14 0 008.5 9.638c1.178 0 2.138-.96 2.138-2.138A2.14 2.14 0 008.5 5.362z"
      ></path>
    </svg>
  );
}
